import { type ApiRequest, type ApiResponse, ProperApiResponse, properCallApi } from '@/api/tenantClient';
import { localeList } from '@/api/registration/dummy/locale';

export interface LocaleData {
  id: number,
  code: string, // e.g. en-US
  countryCode: string, // ISO country code, e.g. AU
  languageCode: string, // ISO language code, e.g. en
  currency: string, // ISO currency code, e.g. AUD
  isActive: boolean, // This the one locale the backend selects for the attendee.
}

export interface LocalListData {
  localeList: LocaleData[],
}

export const localeListQueryKey = 'registration.localeList';

export interface LoadLocaleListRequest {
  eventId: string,
}

export type LoadLocaleListResponse = LocalListData;

export function loadLocaleList(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: LoadLocaleListRequest
  ): Promise<LoadLocaleListResponse> => {
    request.method = 'GET';
    request.endpoint.path = '/api/v1/locales';
    request.endpoint.query = {
      eventId: params.eventId
    };
    return await properCallApi<LoadLocaleListResponse>(request);
  };
}

export interface ChangeLocaleRequest {
  eventId: string,
  localeId: number,
  isGroup: boolean,
  userId: number,
}

export interface ChangeLocaleResponse extends ProperApiResponse {
}

export function changeLocale(createTenantRequest: () => ApiRequest) {
  const request = createTenantRequest();
  return async (
    params: ChangeLocaleRequest
  ): Promise<ChangeLocaleResponse> => {
    request.method = 'POST';
    request.endpoint.path = '/api/v1/locales/change';
    request.endpoint.query = {
      orderType: params.isGroup ? 2 : 0,
      eventId: params.eventId,
      userId: params.userId,
      localeId: params.localeId
    };
    return await properCallApi<{}>(request);
  };
}
